import { Vendor } from "@bluframe/mightychroma-mightytool-frontend-types"

const vendor: Vendor = {
  createdAt: "2021-01-01T00:00:00.000Z",
  id: "6d3241b2-49c7-4a9b-a660-d328efceee96",
  isPublished: true,
  name: "Vinegar Syndrome",
  slug: "vinegar-syndrome",
  updatedAt: "2021-01-01T00:00:00.000Z"
}

export default vendor
